import { Controller, useFormContext } from 'react-hook-form'

import { financialInstitutionRoles } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

export const FinancialInstitutionRole = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.roleInTransaction`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="56. Financial institution's role in transaction"
          input={(props) => <Select {...props} data={financialInstitutionRoles} emptyOption={EMPTY_OPTION} />}
        />
      )}
    />
  )
}
